import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { User } from "../../@core/data/users";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Employee } from "../../models/employee.model";
import { Receipt, ReceiptDetail } from "../../models/receipt.model";
import Shop from "../../models/shop.model";
import { ReceiptService } from "../../services/receipt.service";

@Component({
  selector: "ngx-dialog-receipt-delivery",
  templateUrl: "dialog-receipt-delivery.component.html",
  styleUrls: ["dialog-receipt-delivery.component.scss"],
})
export class DialogReceiptDeliveryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() shop?: Shop;
  @Input() receipt?: Receipt;
  @Input() employeesDeliverer: Employee[] = [];

  loading = false;
  submitted = false;
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    protected ref: NbDialogRef<DialogReceiptDeliveryComponent>,
    private receiptService: ReceiptService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  changeEmployee(value) {
    if (value) {
      this.receipt.employeeDeliveryId = value.objectId;
      this.receipt.employeeDeliveryName = value.objectName;
    }
  }

  saveDelivery() {
    this.loading = true;
    this.submitted = true;

    this.receiptService
      .updateDelivery(this.receipt)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.ref.close(this.receipt);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }
}
